<script lang="ts">
  import type { Snippet } from 'svelte'
  import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
  import Icon from './Icon.svelte'
  import { expandClick } from '../utils/expandClick'

  let {
    variant,
    icon: faIcon,
    eyebrow,
    title,
    lead,
    children,
  }: {
    variant: 'sightseeing' | 'events' | 'blog' | 'language'
    icon: IconDefinition
    eyebrow: string
    title: string
    lead: string
    children: Snippet
  } = $props()
</script>

<div class="feature-card -{variant}" {@attach expandClick}>
  <div class="feature-card-icon">
    <Icon icon={faIcon} />
  </div>
  <div class="feature-card-eyebrow">{eyebrow}</div>
  <h2 class="feature-card-title">{title}</h2>
  <div class="feature-card-lead">{lead}</div>
  <div class="feature-card-action">
    {@render children()}
  </div>
</div>

<style>
  .feature-card {
    border-radius: var(--radius-5);
    padding: var(--space-8) var(--space-9) var(--space-9);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 220px;
    transition: transform var(--transition-medium) ease;
    position: relative;
    overflow: hidden;
    cursor: pointer;

    &:hover {
      transform: scale(var(--scale-hover));
    }

    &:focus-within {
      outline: var(--border-2) solid currentColor;
      outline-offset: 2px;
    }

    &.-sightseeing {
      background-color: var(--color-variant-brand-muted);
      color: var(--color-variant-brand);
    }

    &.-events {
      background-color: var(--color-variant-warning-muted);
      color: var(--color-variant-warning);
    }

    &.-blog {
      background-color: var(--color-variant-success-muted);
      color: var(--color-variant-success);
    }

    &.-language {
      background-color: var(--color-variant-danger-muted);
      color: var(--color-variant-danger);
    }
  }

  .feature-card-icon {
    font-size: var(--font-size-7);
    margin-block-end: var(--space-6);
  }

  .feature-card-eyebrow {
    font-size: var(--font-size-2);
    letter-spacing: var(--letter-spacing-4);
    text-transform: uppercase;
    font-weight: 600;
    margin: 0 0 var(--space-3);
    opacity: var(--opacity-3);
  }

  .feature-card-title {
    color: inherit;
    font-size: var(--font-size-6);
    font-weight: 600;
    line-height: var(--line-height-2);
    margin: 0 0 var(--space-6);
  }

  .feature-card-lead {
    font-size: var(--font-size-4);
    line-height: var(--line-height-4);
    margin: 0 0 var(--space-8);
    opacity: var(--opacity-4);
  }

  .feature-card-action {
    margin-top: auto;
  }
</style>
